/**
 * 处方模板模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取处方模板类型列表
export const typeList = (params) => {
    return req.get('/recipe/type/list', params);
}

// 修改处方模板类型
export const typeEdit = (params) => {
    return req.put('/recipe/type', params);
}

// 新增处方模板类型
export const typeAdd = (params) => {
    return req.post('/recipe/type', params);
}

// 获取处方模板列表
export const recipeList = (params) => {
    return req.get('/recipe/info/list', params);
}

// 修改处方模板
export const recipeEdit = (params) => {
    return req.put('/recipe/info', params);
}

// 新增处方模板
export const recipeAdd = (params) => {
    return req.post('/recipe/info', params);
}

// 获取处方模板详情
export const recipeInfo = (recipeTemplateId) => {
    return req.get(`/recipe/info/${recipeTemplateId}`);
}

// 删除处方模板
export const recipeDelete = (recipeTemplateId) => {
    return req.delete(`/recipe/info/${recipeTemplateId}`);
}

// 处方相反相畏校验
export const checkEffect = (params) => {
    return req.post(`/caseProjectRecipe/checkEffect`, params);
}

// 获取续方信息
export const getRecipeContinue = (params) => {
    return req.get(`/recipe/continue/getRecipeContinue`, params);
}

// 图片转录
export const picToRecipe = (params) => {
    return req.post(`/recipe/continue/picToRecipe`, params);
}

//拒接审方
export const examineContinueNoPass = (params) => {
    return req.post('/recipe/continue/examineContinueNoPass', params);
}

//通过审方
export const examineContinuePass = (params) => {
    return req.post('/recipe/continue/examineContinuePass', params);
}

//删除处方模板类型
export const deleteType = (recipeTemplateTypeIds) => {
    return req.delete(`/recipe/type/${recipeTemplateTypeIds}`, );
}

//重置处方类型排序
export const resetSort = (params) => {
    return req.post(`/recipe/type/resetSort`, params);
}

//重置处方排序
export const recipeResetSort = (params) => {
    return req.post(`/recipe/info/resetSort`, params);
}

//复制单个处方
export const projectCopyApi = (params) => {
    return req.post(`/caseProjectRecipe/projectCopy`, params);
}

//保存处方图片
export const savePrecreiptionImg = (params) => {
    return req.post(`/order/info/precreiption/image/save`, params);
}

//获取处方图片
export const getPrecreiptionImg = (params) => {
    return req.get(`/order/info/precreiption/image/get`, params);
}

// 获取模版类型
export const getType = (params) => {
  return req.get(`/recipe/info/getType`, params);
}
// 搜索处方模版
export const getRecipeSearch = (params) => {
  return req.get(`/recipe/info/search`, params);
}

